// From https://gist.github.com/impressiver/5092952
const commonIgnoreErrors = [
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage',
];

// Custom ignore errors
const ignoreErrors = [
  /GEOCODER_GEOCODE: ZERO_RESULTS/i,
  /GEOCODER_GEOCODE: OVER_QUERY_LIMIT/i,
  /Geocoder failed due to: ERROR/i,

  /Loading CSS/i,

  /AbortError: The operation was aborted/i,
  /Request aborted/i,
  /Network Error/i,
  /NetworkError/,
  // Only ignore client errors (4xx), not server errors (5xx)
  /Request failed with status code 4\d{2}/i,
  /timeout of 0ms exceeded/i,

  /Unexpected end of JSON input/i,
  /Unexpected token < in JSON at position 0/i,

  /ResizeObserver loop limit exceeded/i,
  /ResizeObserver loop completed with undelivered notifications/i,

  /NotAllowedError: The play method is not allowed by the user agent or the platform in the current context, possibly because the user denied permission/i,

  // SendbirdError
  // https://community.sendbird.com/t/sendbird-uikit-react-v2-with-nextjs-error-command-received-no-ack/5025
  /Command received no ack/i,
  /Connection is closed\. Please reconnect\./i,

  // Ably connection race condition errors (expected during cleanup)
  /Connection closed/i,
  /Error: Connection closed/i,
  /Error: Channel attach timed out/i,
  /Error: Channel detach timed out/i,
  /Error: Channel detached/i,
  /Error: Detach request superseded by a subsequent attach request/i,
  /Error: Channel operation failed as channel state is failed/i,
  /Error: Connection to server unavailable/i,

  // Errors caused by the Microsoft Outlook SafeLink crawler
  /Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:[^,]+, ParamCount:\d+/i,

  // Ably
  /Mutex lock timeout exceeded/i,

  // Facebook in-app browser on Android - WebView JavaScript bridge errors
  // Occurs when Java objects are garbage collected during page unload
  // https://github.com/react-native-webview/react-native-webview/issues/323
  /Java object is gone/i,

  // Browser extensions manipulating React DOM (e.g. Grammarly, LastPass, ad blockers)
  // https://github.com/facebook/react/issues/17256
  /Failed to execute 'removeChild' on 'Node'/i,

  // Email marketing bots with malformed URLs (e.g. %%7BUser_ID%7D instead of actual ID)
  /could not be decoded.*caused by an invalid percent-encoding/i,

  // Third-party tracking scripts (OneTrust, etc.)
  /_oTrackingInit/i,

  // Microsoft Word pasted content - contains inline handlers referencing MS Office functions
  // that don't exist in browser context (e.g. onmouseover="msoCommentShow('_com_1')")
  /msoCommentShow is not defined/i,
  /msoCommentHide is not defined/i,

  // Tawk.to live chat widget errors
  /\$_Tawk\.i18next is not a function/i,

  // CookieYes cookie consent widget - fires when client's domain config is outdated
  /Looks like your website URL has changed.*CookieYes/i,

  // Jimo product tour widget load failures
  /Load failed.*usejimo\.com/i,

  // Google Maps API load failures (ad blockers, network issues, quota exceeded)
  /The Google Maps JavaScript API could not load/i,

  // Slick carousel - user-added scripts in custom pages that fail to load jQuery plugin
  /\.slick is not a function/i,

  // iOS WebView bridge errors - occurs when page runs outside native app context
  /window\.webkit\.messageHandlers/i,

  // Sendbird messaging SDK connection errors (race conditions during page navigation)
  /SendbirdError: Connection is required/i,

  // IndexedDB connection lost - browser/OS level issue, not actionable
  /Connection to Indexed Database server lost/i,
];

export default [...commonIgnoreErrors, ...ignoreErrors];
